import script from "./ExcerptBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExcerptBlock.vue?vue&type=script&setup=true&lang=ts"

import "./ExcerptBlock.vue?vue&type=style&index=0&id=0dc0b143&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc0b143"]])

export default __exports__